export enum TAG_COLORS {
    YELLOW,
    WHITE,
    VIOLET,
    TEAL,
    GRAY,
}
